import styled from 'styled-components';

import { COLOR } from '../../../../packages/constants';
import CircleWithPlus from '../../../../packages/icons/circle-with-plus';
import CircleWithMinus from '../../../../packages/icons/circle-with-minus';
import Elimination from '../../../../packages/icons/elimination';
import Edit from '../../../../packages/icons/edit';
import ChevronLeft from '../../../../packages/icons/chevron-left';
import ChevronRight from '../../../../packages/icons/chevron-right';

const iconWidth = '12px';
export const StyledPlus = styled(CircleWithPlus)`
    fill: ${COLOR.BRAND.REPORTING};
    width: ${iconWidth};
    height: ${iconWidth};
`;

export const StyledMinus = styled(CircleWithMinus)`
    fill: ${COLOR.BRAND.REPORTING};
    width: ${iconWidth};
    height: ${iconWidth};
`;

export const StyledElimination = styled(Elimination)`
    fill: ${COLOR.BRAND.REPORTING};
    width: ${iconWidth};
    height: ${iconWidth};
`;

export const StyledEdit = styled(Edit)`
    fill: ${COLOR.DATAGRID.DATAGRID_TEXT};
    width: ${iconWidth};
    height: ${iconWidth};
    position: absolute;
    bottom: 5px;
    right: 2px;
    z-index: 0;
`;

const chevronAttrs = `
    fill: ${COLOR.DATAGRID.DATAGRID_TEXT};
    width: 10px;
    height: 10px;
`;

export const StyledChevronRight = styled(ChevronRight)`
    ${chevronAttrs}
`;

export const StyledChevronLeft = styled(ChevronLeft)`
    ${chevronAttrs}
`;
